const imagePathRegex = /((?:https?:\/\/|\/)?[^\s"'()]+\.(?:webp|png|jpe?g|gif))/i;

export const isImagePath = (value?: string | null) => {
  if (!value) return false;
  return /\.(webp|png|jpe?g|gif)(\?.*)?$/i.test(value.trim());
};

export const extractImagePath = (value?: string | null) => {
  if (!value) return null;
  const trimmed = value.trim();
  if (isImagePath(trimmed) && !/\s/.test(trimmed)) return trimmed;
  const match = trimmed.match(imagePathRegex);
  if (match) return match[1];
  return isImagePath(trimmed) ? trimmed : null;
};

export const stripImagePathFromText = (value?: string | null) => {
  if (!value) return '';
  const imagePath = extractImagePath(value);
  if (!imagePath) return value.trim();
  return value.replace(imagePath, '').trim();
};

export const hasIndependentGroupOptions = (question: any, fallbackLevel?: number) => {
  const level = Number(question?.level ?? fallbackLevel ?? 0);
  const part = String(question?.part || '').trim().toUpperCase();
  return level === 4 && (part === 'L4' || part === 'R5');
};

export const splitSequenceTokens = (value?: string | null) =>
  String(value || '')
    .split(';')
    .map(token => token.trim())
    .filter(Boolean);

export const getSequenceComposerTokens = (question: any, fallbackLevel?: number) => {
  const level = Number(question?.level ?? fallbackLevel ?? 0);
  const part = String(question?.part || '').trim().toUpperCase();
  const questionTokens = splitSequenceTokens(question?.question ?? question?.question_text);
  const optionTokens = Array.isArray(question?.options)
    ? question.options.map((token: unknown) => String(token ?? '').trim()).filter(Boolean)
    : [];

  // HSK4 R3 stores the three sentence blocks in options and leaves question_text empty.
  // HSK W1 stores the deliberately scrambled word blocks in question_text.
  if (level === 4 && part === 'R3' && optionTokens.length > 0) return optionTokens;
  return questionTokens.length > 0 ? questionTokens : optionTokens;
};

export const resolveQuestionImagePath = (question: any, fallbackLevel?: number) => {
  const questionTextImage = extractImagePath(question?.question ?? question?.question_text);
  if (questionTextImage) return questionTextImage;

  const level = Number(question?.level ?? fallbackLevel ?? 0);
  const part = String(question?.part || '').trim().toUpperCase();
  if (level !== 4 || part !== 'W2') return null;

  const mediaImage = extractImagePath(question?.media);
  if (mediaImage) return mediaImage;

  if (!Array.isArray(question?.options)) return null;
  return question.options.map((option: unknown) => extractImagePath(String(option ?? ''))).find(Boolean) ?? null;
};
